module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fb-Gd-Hc 后背.cdc2a54d.png";